import { Alert, Stack, Typography } from "@mui/material";
import { PatriotResult } from "../../components/BlacklistNameSearch/types";

export default function PatriotResultAlert({ patriotSearchResult }: { patriotSearchResult: PatriotResult[] }) {
  if (patriotSearchResult.length == 0) return <></>;
  const names = patriotSearchResult
    .flatMap((r) => r.results)
    .map((name, index) => `${index + 1}) ${name}`)
    .join(", ");

  return (
    <Alert severity="error">
      <Stack direction="column" spacing={2}>
        <Typography variant="body1" sx={{ display: "inline" }}>
          Patriot search matches found: {names}!!{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>DO NOT CONTINUE </span>
          transaction until confirmed to be not a match.
        </Typography>
      </Stack>
    </Alert>
  );
}
